import { createClient } from '@supabase/supabase-js';
import { Capacitor } from '@capacitor/core';

// "Stay logged in" only applies on the web (a shared computer). The phone
// app always stays signed in, like any other app; Face ID lock protects it.
const staySignedIn = () =>
  Capacitor.isNativePlatform() || window.localStorage.getItem('sacredmothr_stay_logged_in') !== 'false';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder';

// Exported so the app can read the stored sign-in with no signal (offlineSession.js)
export const customStorage = {
  getItem: (key) => {
    return window.localStorage.getItem(key) || window.sessionStorage.getItem(key);
  },
  setItem: (key, value) => {
    if (staySignedIn()) {
      window.localStorage.setItem(key, value);
      window.sessionStorage.removeItem(key);
    } else {
      window.sessionStorage.setItem(key, value);
      window.localStorage.removeItem(key);
    }
  },
  removeItem: (key) => {
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  }
};

// Typed with the generated schema (src/types/database.types.ts, `npm run gen:types`),
// so editors and .ts files see real table, column and RPC types.
/** @type {import('@supabase/supabase-js').SupabaseClient<import('../types/database.types').Database>} */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: customStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});
